import React from 'react'
import styles from './Footer.module.scss'

function Footer() {
  return (
    <div className={styles.Footer}>
        <p>©2024 Forester. Site by BT Dev</p>
    </div>
  )
}

export default Footer